export default __webpack_public_path__ + "static/media/compas_project_formation_remplacer.ea84ba10.gif";